"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const config_service_1 = require("../../../../../shared/config/config.service");
let BuildingBlockFormComponent = class BuildingBlockFormComponent {
    constructor(configService) {
        this.configService = configService;
        this.edit = new core_1.EventEmitter();
        this.selectOptions = {};
        this.finishEdit = () => {
            this.edit.emit({ block: null, componentUuid: '' });
        };
        this.addSelectable = (block) => {
            if (!block.selectables)
                block.selectables = [];
            block.selectables.push('');
        };
        /** Used to track array of strings for Input block */
        this.trackSelectables = (index) => index;
        this.removeSelectable = (block, index) => {
            block.selectables.splice(index, 1);
        };
        this.selectOptions = {
            inputTypes: this.configService.getConstant(config_service_1.ConstantTypes.INPUT_TYPES),
            vehicleFields: this.configService.getConstant(config_service_1.ConstantTypes.VEHICLE_FIELDS),
            optionTypes: this.configService.getConstant(config_service_1.ConstantTypes.OPTION_BLOCK_TYPES),
        };
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], BuildingBlockFormComponent.prototype, "block", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], BuildingBlockFormComponent.prototype, "edit", void 0);
BuildingBlockFormComponent = __decorate([
    (0, core_1.Component)({
        selector: 'building-block-form',
        templateUrl: require('./block-form.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof config_service_1.ConfigService !== "undefined" && config_service_1.ConfigService) === "function" ? _a : Object])
], BuildingBlockFormComponent);
exports.default = BuildingBlockFormComponent;
